// removed by extract-text-webpack-plugin
module.exports = {"root":"_3l4EwibiinSJhaxcsRX_5g"};


//////////////////
// WEBPACK FOOTER
// ./src/components/List/List.scss
// module id = 1278
// module chunks = 1